import { render, staticRenderFns } from "./ChangeLogComponent.vue?vue&type=template&id=0e106743&scoped=true"
import script from "./ChangeLogComponent.vue?vue&type=script&lang=js"
export * from "./ChangeLogComponent.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogComponent.vue?vue&type=style&index=0&id=0e106743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e106743",
  null
  
)

export default component.exports